import { Outlet } from "react-router"
import { ReturnToStatementBanner } from "./ReturnToStatementBanner"

export function MasterDataLayout() {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex flex-1 flex-col overflow-hidden px-6 pb-6 pt-4">
        <div className="shrink-0">
          <ReturnToStatementBanner />
        </div>
        <div
          className="min-h-0 flex-1 overflow-hidden"
          data-testid="master-data-outlet-region"
        >
          <Outlet />
        </div>
      </div>
    </div>
  )
}
